const s = {
  name: "Processing",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M35,10c-0.3-0.5-0.6-0.9-1-1.3l0,0C30.7,4.6,25.7,2,20,2V0c6.3,0,11.9,2.9,15.6,7.4C35.7,7.6,35.9,7.8,36,8V0
			h2v12H26v-2H35z"/>
		<path class="st0" d="M14,28H2v12h2v-8c0.1,0.2,0.3,0.4,0.4,0.6C8.1,37.1,13.7,40,20,40v-2c-5.7,0-10.7-2.6-14-6.7l0,0
			c-0.3-0.4-0.7-0.9-1-1.3h9V28z"/>
		<path class="st0" d="M30,35v-9h-2v12h12v-2h-8c0.2-0.1,0.4-0.3,0.6-0.4C37.1,31.9,40,26.3,40,20h-2c0,5.7-2.6,10.7-6.7,14l0,0
			C30.9,34.3,30.5,34.7,30,35z"/>
		<path class="st0" d="M0,4h8C7.8,4.1,7.6,4.3,7.4,4.4C2.9,8.1,0,13.7,0,20h2C2,14.3,4.6,9.3,8.7,6l0,0C9.1,5.7,9.5,5.3,10,5v9h2V2
			H0V4z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Processing
};
